var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-title',{staticClass:"mb-6"},[_c('base-text',{attrs:{"value":_vm.title}}),(_vm.isConfirmedStatus)?_c('base-icon',{staticClass:"ml-2",attrs:{"icon":"fas fa-check","color":"completed-outline"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }